<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Liste des affaires</h2>
    <p class="page-subtitle">Gérez les affaires et leurs clients associés</p>
  </div>
  <a routerLink="/affaires/new" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouvelle affaire
  </a>
</div>

<div class="card shadow-sm">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange($event)"
          placeholder="Rechercher une affaire ou un client..."
          class="search-input"
        />
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivées
        </label>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
        <tr>
          <th mat-sort-header="numeroAffaire">N° Affaire</th>
          <th mat-sort-header="createdAt">Créée le</th>
          <th mat-sort-header="client">Client</th>
        </tr>
      </thead>
      <tbody>
        @for (affaire of affaires(); track affaire.id) {
          <tr (click)="onEdit(affaire)" class="clickable-row" [class.archived-row]="affaire.archived">
            <td>
              {{ affaire.numeroAffaire }}
              @if (affaire.archived) {
                <span class="badge-archived">Archivée</span>
              }
            </td>
            <td>{{ affaire.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ affaire.client.denomination }}</td>
          </tr>
        } @empty {
          <tr class="empty-row">
            <td colspan="3">
              <div class="empty-state">
                <mat-icon class="empty-icon" aria-hidden="true">inbox</mat-icon>
                <p>Aucune affaire trouvée</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
